import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { AgentReport } from '@core/models/agent-report.model';

@Injectable()
export class AgentReportEntityService extends EntityCollectionServiceBase<AgentReport> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('AgentReport', serviceElementsFactory);
  }
}